import { useTranslation } from "react-i18next";

export default function IntroText() {
  const { t } = useTranslation("kozijn-reparatie");

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("intro.h2")}
        </h2>
        <div className="flex flex-col gap-6 md:gap-8">
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("intro.p1")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("intro.p2")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("intro.p3")}
          </p>
          {t("intro.p4") && (
            <div className="bg-[#FFF9E0] border border-[#FFD600] rounded-xl p-5 md:p-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[#FFD600] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-coins-line text-brand-text text-sm w-5 h-5 flex items-center justify-center"></i>
                </div>
                <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
                  {t("intro.p4")}{" "}
                  <a href="/blog/isde-subsidie-2026/" className="font-semibold text-brand-text underline hover:text-brand-text/70 transition-colors">
                    Lees meer
                  </a>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}